/* 188 §B.1 — THE TABLE SHELL, defined from the union of what every `<table>` in
 * src/ passes (187's census, `docs/187-elements-census/table.md`, read on
 * 2bbd0c54 and re-measured on this branch: the same population, 52 elements
 * in 30 files). The union of attributes on `<table>` is THREE — `style` (44
 * sites), `className` (7) and `ref` (1, TimeEntryTable's) — and children are
 * content at every site. This element takes exactly those, forwards them
 * unchanged, and renders `<table>`: a site converted onto it renders the same
 * DOM attribute for attribute (React omits an undefined `className`/`style`,
 * so a site that passed nothing still renders a bare `<table>`).
 *
 * It is a SHELL, not a data grid: `<thead>`, `<tr>`, `<th>`, `<td>` stay at the
 * call sites, with their 263 style literals and 100 classNames, which this
 * brief does not touch.
 *
 * The style vocabulary measured across the 44 `style` sites, for the pass that
 * will one day name it (S3c / spacing, ruled 187 (4) — after the elements,
 * never before): `width: "100%"` (the stylesheet's own `table { width: 100% }`
 * restated; ×15 alone), `borderCollapse: "collapse"` (also the stylesheet's),
 * `fontSize: FS.s10 | s10_5 | s11 | s11_5`, `marginTop: 4 | 8`, `minWidth: 0 |
 * 260 | 520`, and one comment inside an object literal (DocTrackingMatrix).
 * Naming those as props would be an improvement riding on an extraction
 * (SESSION_RULES rule 3), so this commit forwards `style` as the sites wrote
 * it. `className` carries the four CSS-dressed families as they are:
 * `costs-table`, `teTable` / `teTable-page`, `elist` (+ a per-list class),
 * `colTbl`.
 *
 * `forwardRef` because TimeEntryTable reads `tableRef.current.tHead` to
 * measure its sticky header — a ref is part of the union, not a convenience.
 */
import React, { forwardRef } from "react";
import type { CSSProperties, ReactNode } from "react";

interface Props {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

const Table = forwardRef<HTMLTableElement, Readonly<Props>>(function Table(
  { className, style, children },
  ref,
) {
  return (
    <table ref={ref} className={className} style={style}>
      {children}
    </table>
  );
});

/* The name the 57c EntityList freeze records: `elementShape`
   (recordings/50-view-blocks/harness.mjs) reads `type.displayName || type.name`
   and a forwardRef object has neither, so without this line every converted
   `<table>` would be frozen as `[anonymous]`. React itself reads nothing here. */
Table.displayName = "Table";

export default Table;
